import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { formatPrice, isNotEmpty, compose } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'
import actions from 'redux/actions'

import billMessages from 'components/payment/Bill/messages'


const defaultPlacement = 'queue'
const emptyPlacement = 'empty queue first cell click'


const queueNonSubscribedDecorator = (ComposedComponent) => {

  class QueueNonSubscribedDecorator extends Component {

    static propTypes = {
      items: PropTypes.arrayOf(PropTypes.object),
      isFetching: PropTypes.bool,
      isSubscriptionCancelled: PropTypes.bool,
    }

    static childContextTypes = {
      paymentPage: PropTypes.shape({
        applePayBeginAction: PropTypes.func,
        getApplePayOrderInfo: PropTypes.func,
        getInquireAction: PropTypes.func,
        applePayCommitAction: PropTypes.func,
      }),
    }

    getChildContext() {

      return {
        paymentPage: {
          applePayBeginAction: actions.models.payment.beginSubscriptionUsingApplePay,
          getApplePayOrderInfo: this.getApplePayOrderInfo,
          getInquireAction: () => actions.view.paymentPage.inquireSubscription,
          applePayCommitAction: actions.models.payment.commitSubscriptionUsingApplePay,
        },
      }
    }

    getApplePayOrderInfo = () => {
      const { intl, bill: { items, price } } = this.props

      const lineItems = items
        .filter(({ amount }) => Boolean(amount) && amount !== 0)
        .map(({ label: { values, ...label }, amount }) => ({
          label: intl.formatMessage(label, values),
          amount,
        }))
        .map(({ label, amount }) => {
          const isAmountFormatted = typeof amount === 'string' && /\d+\.\d+/.test(amount)

          return {
            label,
            amount: isAmountFormatted ? amount : formatPrice(amount, true, false),
          }
        })
        .map(({ label, amount }) => ({
          label,
          amount: amount.replace(/\s/, ''),
        }))

      return {
        lineItems,
        total: {
          label: 'Total',
          amount: price ? formatPrice(price, true, false) : 0,
        },
      }
    }

    render() {
      const { items, isFetching, isSubscriptionCancelled, ...rest } = this.props

      let firstItem = {}
      let restItems = []
      let isEmpty = true

      if (items && items.length > 0) {
        [ firstItem, ...restItems ] = items

        // Month empty updates only after query, but product could be already removed
        isEmpty = firstItem.empty || (isNotEmpty(firstItem.products) && firstItem.products[0].isEmpty)

        if (isEmpty) {
          // show only 12 months
          restItems = items.slice(0, 12)
        }
      }

      const addToQueuePlacement = isEmpty ? emptyPlacement : defaultPlacement

      const props = {
        ...rest,
        isFetching,
        firstItem,
        restItems,
        isEmpty,
        addToQueuePlacement,
        isSubscriptionCancelled,
      }

      return (
        <ComposedComponent {...props} />
      )
    }
  }


  return compose(
    connect({
      items: 'models.queue.items',
      isFetching: 'models.queue.isFetching',
      isSubscriptionCancelled: 'models.subscription.isCancelled',
      bill: (state) => {
        const {
          view: {
            paymentPage: {
              bill: { price, tax, discount: billDiscount },
              subscription: { price: subscriptionPrice, shipping: subscriptionShipping, discount: subscriptionDiscount },
            },
          },
        } = state

        const items = []

        items.push({
          id: 'billSubscriptionProductRow',
          label: billMessages.product.monthlySubscription,
          value: formatPrice(subscriptionPrice, true),
          amount: formatPrice(subscriptionPrice, true, false),
        })

        // Shipping ----------------------------------------------------------- /

        items.push({
          id: 'billSubscriptionShippingRow',
          label: billMessages.shipping.common,
          value: subscriptionShipping ? formatPrice(subscriptionShipping, true) : billMessages.free,
          amount: formatPrice(0, true, false),
          brand: true,
        })

        // Tax ---------------------------------------------------------------- /

        items.push({
          id: 'billTaxRow',
          label: billMessages.tax,
          value: formatPrice(tax, true),
          amount: formatPrice(tax, true, false),
        })

        // Discount ----------------------------------------------------------- /

        if (subscriptionDiscount) {
          items.push({
            id: 'billSubscriptionDiscountRow',
            label: billMessages.discount.subscription,
            value: typeof subscriptionDiscount === 'string' ? subscriptionDiscount : formatPrice(subscriptionDiscount, true),
            amount: formatPrice(billDiscount, true, false).replace(/\s*/g, ''),
            brand: true,
          })
        }

        return {
          items,
          price,
        }
      },
    }),
    injectIntl,
  )(QueueNonSubscribedDecorator)
}


export default queueNonSubscribedDecorator
